<div class="container sub-header">
    <ul *ngFor="let item of items" class="nav nav-tabs justify-content-center d-flex">
        <li class="nav-item">
            <a class="nav-link nav-item-link"
               [class.active]="item.id == currentItem"
               [class.disableDiv]="!item.permission"
               (click)="handleTrigger(item.trigger, item.title)">{{item.subtitle}}</a>
        </li>
    </ul>
</div>

<div class="col-lg-12 col-md-12 col-xs-12">
    <div class="title-description">
        <i [class]="currentIcon" style="margin-right: 0.75rem;"></i>
        {{currentTitle}}
    </div>
</div>